import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'rpe-ui-button',
  templateUrl: './ui-button.component.html',
  styleUrls: ['./ui-button.component.scss'],
})

export class UiButtonComponent {
  @Input() color: ThemePalette = 'primary';
  @Input() type: string = 'button';
  @Input() raised: boolean = false;
  @Input() flat: boolean = false;
  @Input() stroked: boolean = false;
  @Input() basic: boolean = false;
  @Input() disabled: boolean = false;
  @Input() icon: string = '';
  @Input() isLoading: boolean = false;
  @Input() spinnerColor: string = 'primary';
  @Input() bg_gray: boolean = false
  @Input() bg_blue: boolean = false
  @Input() mat_menu: boolean = false
  @Input() full_width: boolean = false
  @Input() cart_button: boolean = false
  @Input() bg_white: boolean = false
  @Input() bg_orange: boolean = false
  @Input() colorWhite: boolean = false
  @Input() button: boolean = false
  @Input() button_custom: boolean = true
  @Input() landing_button: boolean = false

  @Output() onClick: EventEmitter<void> = new EventEmitter<void>()

  getClass() {
    return {
      [`mat-${this.color}`]: true,
      'mat-icon-button': !!this.icon,
      'background-gray': this.bg_gray,
      'background-blue': this.bg_blue,
      'background-white': this.bg_white,
      'background-orange': this.bg_orange,
      'mat-menu': this.mat_menu,
      'full-width': this.full_width,
      'cart-button': this.cart_button,
      'color-white': this.colorWhite,
      'button': this.button,
      'button-custom': this.button_custom,
      'landing-button': this.landing_button
    };
  }

  onEmit(): void {
    this.onClick.emit()
  }
}
